function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Cookies from 'js-cookie';

var Popup = /*#__PURE__*/function () {
  function Popup() {
    _classCallCheck(this, Popup);
  }

  _createClass(Popup, null, [{
    key: "init",
    value: function init() {
      Popup.overlays = document.querySelectorAll('.popup');
      if (!Popup.overlays.length) return;

      _toConsumableArray(Popup.overlays).forEach(function (overlay) {
        if (overlay.classList.contains('disclaimer')) {
          Popup.disclaimer(overlay);
        } else if (overlay.classList.contains('country')) {
          Popup.country(overlay);
        } else {
          Popup.popup(overlay);
        }
      });
    }
  }, {
    key: "popup",
    value: function popup($popup) {
      var $cookieAgreeButton = $popup.querySelector('.actions button');
      var cookiesValidityPeriod = 30; // in days

      var cookieIdentification = 'roche-medinfo-popup';
      var cookieItem = Cookies.get(cookieIdentification);
      var validityDate = new Date();

      var createCookie = function createCookie() {
        validityDate.setDate(validityDate.getDate() + cookiesValidityPeriod);
        Cookies.set('roche-medinfo-popup', '1', {
          expires: validityDate
        });
        $popup.classList.add('confirmed');
        document.body.classList.remove('is-modal-open');
        return false;
      };

      if (!cookieItem) {
        $popup.classList.remove('confirmed');
        document.body.classList.add('is-modal-open');
      } else {
        $popup.classList.add('confirmed');
        document.body.classList.remove('is-modal-open');
      }

      $cookieAgreeButton.addEventListener('click', createCookie);
    }
  }, {
    key: "disclaimer",
    value: function disclaimer($popup) {
      var $popupLink = $popup.querySelector('a');
      var $popupCancel = $popup.querySelectorAll('button');

      var popupHandler = function popupHandler(event, link) {
        if (document.querySelector('main').classList.contains('dashboard-modern')) {
          return;
        }

        event.preventDefault();
        $popupLink.setAttribute('href', link);
        $popup.classList.add('opened');
        return false; //eslint-disable-line
      };

      document.addEventListener('click', function (e) {
        // loop parent nodes from the target to the delegation node
        for (var target = e.target; target && target !== this; target = target.parentNode) {
          if (target.matches('.external-link') || target.matches('.show-Roche-pop-up-link') || target.matches('.topic-description a')) {
            popupHandler(e, target.getAttribute('href'));
            break;
          }
        }
      }, false);

      _toConsumableArray($popupCancel).forEach(function (link) {
        link.addEventListener('click', function () {
          $popup.classList.remove('opened');
        });
      });

      $popupLink.addEventListener('click', function () {
        $popup.classList.remove('opened');
      });
    }
  }]);

  return Popup;
}();

export default Popup;